const state = {
  // 资产类别（大类）
  assetsFType: [{ label: "债权", value: "0" }, { label: "物权", value: "1" }],
  // 资产类别（小类）
  assetsType: [
    { label: "存量债权", value: "0" },
    { label: "受托债权", value: "1" },
    { label: "受托物权", value: "2" },
    { label: "存量物权", value: "3" }
  ]
};

const getters = {
  assetsFType: state => state.assetsFType,
  assetsType: state => state.assetsType
};

export default {
  namespaced: true,
  state,
  getters
};
